import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ThemeToggle from "./ThemeToggle";
import LanguageToggle from "./LanguageToggle";
import SearchBox from "./SearchBox";
import styles from "./Sidebar.module.css";

export default function Sidebar() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const NAV = [
    {
      heading: t("sidebar.groupStart"),
      links: [{ to: "/docs/kira-arts/getting-started", label: t("sidebar.installation") }],
    },
    {
      heading: t("sidebar.groupCards"),
      links: [
        { to: "/docs/kira-arts/cards/profile", label: t("sidebar.profileCard") },
        { to: "/docs/kira-arts/cards/welcome-leave", label: t("sidebar.welcomeLeave") },
        { to: "/docs/kira-arts/cards/levelup", label: t("sidebar.levelUpCard") },
        { to: "/docs/kira-arts/cards/achievement", label: t("sidebar.achievementCard") },
        { to: "/docs/kira-arts/cards/ship", label: t("sidebar.shipCard") },
        { to: "/docs/kira-arts/cards/leaderboard", label: t("sidebar.leaderboardCard") },
        { to: "/docs/kira-arts/cards/now-playing", label: t("sidebar.nowPlayingCard") },
        { to: "/docs/kira-arts/cards/giveaway", label: t("sidebar.giveawayCard") },
        { to: "/docs/kira-arts/cards/birthday", label: t("sidebar.birthdayCard") },
        { to: "/docs/kira-arts/cards/marriage", label: t("sidebar.marriageCard") },
        { to: "/docs/kira-arts/cards/weekly-recap", label: t("sidebar.weeklyRecapCard") },
        { to: "/docs/kira-arts/cards/code-snippet", label: t("sidebar.codeSnippetCard") },
      ],
    },
    {
      heading: t("sidebar.groupSystem"),
      links: [{ to: "/docs/kira-arts/color-system", label: t("sidebar.colorRules") }],
    },
    {
      heading: t("sidebar.groupTry"),
      links: [{ to: "/docs/kira-arts/playground", label: t("sidebar.playgroundLink") }],
    },
  ];

  return (
    <aside className={styles.sidebar}>
      <div className={styles.topRow}>
        <Link to="/docs/kira-arts" className={styles.brand}>
          kira<span>-arts</span>
        </Link>
        <button
          type="button"
          className={styles.menuToggle}
          aria-expanded={open}
          aria-label={t("sidebar.toggleMenu")}
          onClick={() => setOpen((v) => !v)}
        >
          <span className={open ? `${styles.bar} ${styles.barTop}` : styles.bar} />
          <span className={open ? `${styles.bar} ${styles.barMid}` : styles.bar} />
          <span className={open ? `${styles.bar} ${styles.barBottom}` : styles.bar} />
        </button>
      </div>

      <div className={styles.searchRow}>
        <SearchBox />
      </div>

      <nav className={open ? `${styles.nav} ${styles.navOpen}` : styles.nav}>
        {NAV.map((group) => (
          <div key={group.heading} className={styles.group}>
            <p className={styles.heading}>{group.heading}</p>
            {group.links.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  isActive ? `${styles.link} ${styles.linkActive}` : styles.link
                }
              >
                {link.label}
              </NavLink>
            ))}
          </div>
        ))}

        <div className={styles.footer}>
          <ThemeToggle />
          <LanguageToggle />
        </div>
      </nav>
    </aside>
  );
}
